<template>
  <div id="app" style="font-family: Arial,微软雅黑,serif">
    <acn-head v-if="this.$route.path !== '/'"></acn-head>
    <router-view />
    <acn-foot v-if="this.$route.path !== '/'"></acn-foot>
  </div>
</template>

<script>
import acnHead from '@/components/acnHead'
import acnFoot from '@/components/acnFoot'
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    acnHead,
    acnFoot
  },
  created () {
    axios.get('/locale/en_US.json').then(res => this.$i18n.setLocaleMessage('en-US', res.data))
    axios.get('/locale/zh_CN.json').then(res => this.$i18n.setLocaleMessage('zh-CN', res.data))
    console.log('author: @liujianchao')
  },
  methods: {
    ...mapMutations(['setWidth'])
  },
  computed: {
    ...mapGetters(['isEn'])
  },
  mounted () {
    window.onresize = () => {
      this.setWidth(document.documentElement.clientWidth)
    }
    if (!this.isEn) {
      this.$i18n.locale = 'zh-CN'
    }
  }
}
</script>

<style lang="less">
  .navigation {
    width: 170px;
    color: #404040;
    border-right: 1px #00023d solid;
    position: absolute;
    > div {
      padding-right: 20px;
      text-align: right;
      cursor: pointer;
      font-size: 16px;
      line-height: 32px;
    }
  }

  .navigation_m {
    padding: 20px;
    background: #7f1f20;
    color: white;
    position: absolute;
    > div {
      padding-right: 20px;
      text-align: right;
      font-size: 20px;
      margin: 10px 0;
    }
  }

  .active_m {
    span {
      border-bottom: 1px white solid;
    }
  }

  .active {
    span {
      border-bottom: 1px #7F1F20 solid;
      color: #7F1F20;
    }
    path {
      fill: #7F1F20 !important;
    }
  }

  .mw1200 {
    max-width: 1200px;
    margin: 0 auto;
  }

  .m20 {
    margin: 0 20px;
  }

  .mlr {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }

  .hover_red:hover {
    color:  #7F1F20 !important;
    path {
      fill: #7F1F20 !important;
    }
  }

  .img_trans {
    transition: all 0.3s;
    &:hover {
      transform: scale(1.1);
    }
  }

  @font-face {
    font-family: "MonotypeCorsiva";
    src: url('assets/MTCORSVA.TTF');
  }

  .h1_p {
    max-width: 1200px;
    margin: 60px auto 30px auto;
    h1 {
      font-size: 28px;
      color: #7F1F20;
      margin: 0;
    }

    p {
      font-size: 18px;
      color: #595959;
      font-family: MonotypeCorsiva,Arial,楷体,serif;
      margin: 0;
      line-height: 1.2;
    }
  }

  .f36 {
    font-size: 36px !important;
  }

  .f30 {
    font-size: 30px !important;
  }

  .f24 {
    font-size: 24px !important;
  }

  .f20 {
    font-size: 20px !important;
  }

  .f26 {
    font-size: 26px !important;
  }

  .f16 {
    font-size: 16px !important;
  }

  .f18 {
    font-size: 18px !important;
  }

  .ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link {
    border: none !important;
  }
</style>
